const UserPanelHome = ({ user, setTab }) => {
  return (
    <div className="AccHomeTab d-flex flex-column justify-content-center align-items-center mt-5">
      <div className="row container justify-content-center mt-3">
        <div className="acc-panel-btn-container col-6 col-md-6 col-lg-4 d-flex justify-content-center my-2 ">
          <button
            onClick={() => setTab("orders")}
            className="acc-panel-btn btn btn-outline-info d-flex py-2 py-md-4 px-2 px-md-3"
          >
            <div className="col-3 col-md-3 d-flex flex-column justify-content-center h-md-100 mb-0">
              <img
                className="acc-panel-icon img-fluid pe-2 mb-0"
                src="/images/icons/orders2.svg"
                alt=""
              />
            </div>
            <div className="col-12 col-md-9 lead text-start d-flex flex-column justify-content-center h-md-100">
              <p className="acc-panel-title mb-0">Your Orders</p>
              <p className="acc-panel-desc text-muted mb-0">
                Track orders or buy again
              </p>
            </div>
          </button>
        </div>
        <div className="acc-panel-btn-container col-6 col-md-6 col-lg-4 d-flex justify-content-center my-2">
          <button
            onClick={() => setTab("lists")}
            className="acc-panel-btn btn btn-outline-info d-flex py-2 py-md-4 px-2 px-md-3"
          >
            <div className="col-3 col-md-3 d-flex flex-column justify-content-center h-md-100 mb-0">
              <img
                className="acc-panel-icon img-fluid pe-2 mb-0"
                src="/images/icons/lists.svg"
                alt=""
              />
            </div>
            <div className="col-12 col-md-9 lead text-start d-flex flex-column justify-content-center h-md-100">
              <p className="acc-panel-title mb-0">Your Lists</p>
              <p className="acc-panel-desc text-muted mb-0">
                View and manage your lists
              </p>
            </div>
          </button>
        </div>
        <div className="acc-panel-btn-container col-6 col-md-6 col-lg-4 d-flex justify-content-center my-2 ">
          <button
            onClick={() => setTab("address")}
            className="acc-panel-btn btn btn-outline-info d-flex py-2 py-md-4 px-2 px-md-3"
          >
            <div className="col-3 col-md-3 d-flex flex-column justify-content-center h-md-100 mb-0">
              <img
                className="acc-panel-icon img-fluid pe-2 mb-0"
                src="/images/icons/addresses.svg"
                alt=""
              />
            </div>
            <div className="col-12 col-md-9 lead text-start d-flex flex-column justify-content-center h-md-100">
              <p className="acc-panel-title mb-0">Your Addresses</p>
              <p className="acc-panel-desc text-muted mb-0">
                Manage your addresses
              </p>
            </div>
          </button>
        </div>
        <div className="acc-panel-btn-container col-6 col-md-6 col-lg-4 d-flex justify-content-center my-2 ">
          <button
            onClick={() => setTab("settings")}
            className="acc-panel-btn btn btn-outline-info d-flex py-2 py-md-4 px-2 px-md-3"
          >
            <div className="col-3 col-md-3 d-flex flex-column justify-content-center h-md-100 mb-0">
              <img
                className="acc-panel-icon img-fluid pe-2 mb-0"
                src="/images/icons/payments.svg"
                alt=""
              />
            </div>
            <div className="col-12 col-md-9 lead text-start d-flex flex-column justify-content-center h-md-100">
              <p className="acc-panel-title mb-0">Your Payments</p>
              <p className="acc-panel-desc text-muted mb-0">
                Manage payment methods
              </p>
            </div>
          </button>
        </div>
        <div className="acc-panel-btn-container col-6 col-md-6 col-lg-4 d-flex justify-content-center my-2 ">
          <button
            onClick={() => setTab("settings")}
            className="acc-panel-btn btn btn-outline-info d-flex py-2 py-md-4 px-2 px-md-3"
          >
            <div className="col-3 col-md-3 d-flex flex-column justify-content-center h-md-100 mb-0">
              <img
                className="acc-panel-icon img-fluid pe-2 mb-0"
                src="/images/icons/account_settings.svg"
                alt=""
              />
            </div>
            <div className="col-12 col-md-9 lead text-start d-flex flex-column justify-content-center h-md-100">
              <p className="acc-panel-title mb-0">Account Settings</p>
              <p className="acc-panel-desc text-muted mb-0">
                Manage your account settings
              </p>
            </div>
          </button>
        </div>
        <div className="acc-panel-btn-container col-6 col-md-6 col-lg-4 d-flex justify-content-center my-2 ">
          <button
            onClick={() => setTab("settings")}
            className="acc-panel-btn btn btn-outline-info d-flex py-2 py-md-4 px-2 px-md-3"
          >
            <div className="col-3 col-md-3 d-flex flex-column justify-content-center h-md-100 mb-0">
              <img
                className="acc-panel-icon img-fluid pe-2 mb-0"
                src="/images/icons/customer_support.svg"
                alt=""
              />
            </div>
            <div className="col-12 col-md-9 lead text-start d-flex flex-column justify-content-center h-md-100">
              <p className="acc-panel-title mb-0">Customer Support</p>
              <p className="acc-panel-desc text-muted mb-0">
                Get help with your account
              </p>
            </div>
          </button>
        </div>
      </div>
    </div>
  )
}

export default UserPanelHome
